import React, { Fragment } from 'react';

const vocabulariesLinks = {
  CHEMBL: 'https://www.ebi.ac.uk/chembl/explore/compound/',
  CHEBI: 'https://www.ebi.ac.uk/chebi/CHEBI:',
  DRUGBANK: 'https://go.drugbank.com/drugs/',
  MESH: 'https://meshb.nlm.nih.gov/record/ui?ui=',
  PUBCHEM: 'https://pubchem.ncbi.nlm.nih.gov/compound/',
};

function FilasDrug({ left, resultado, lista }) {
  const baseUrl = vocabulariesLinks[left];
  const link = baseUrl ? `${baseUrl}${resultado}` : null;
  return (
    <Fragment>
      <tr>
        <td>{left}:</td>
        <td>
          {link ? (
            <a href={link} className="mapId" target="_blank" rel="noreferrer">
              {resultado}
            </a>
          ) : (
            <span>{resultado}</span>
          )}
        </td>
        <td>
          <span>{lista}</span>
        </td>
      </tr>
    </Fragment>
  );
}

export default FilasDrug;
